@if (!showSearchView && !showRecentSearch) {
    <div>
        <div class="container max-width">
            <div class="clearfix"></div>
            <div class="space-30"></div>
            <div class="clearfix"></div>
            <div>
                <div class="category-product-wrapper" appMatchHeight>
                    @for (product of filteredMenu; track product) {
                        <div>
                            <div class="row square_layout">
                                <div class="image">
                                    <img
                                        src="{{ DEPLOY_URL }}/assets/images/missing.png"
                                        [imageSrc]="product.image"
                                        [alt]="product.description"
                                        appDeferImageLoad />
                                </div>
                                <div class="info">
                                    <div class="label">
                                        <div style="display: flex; width: 100%; align-items: flex-start; gap: 4px">
                                            <div style="margin-top: 2px" [ngClass]="product.veg ? 'veg' : 'non-veg'"></div>
                                            <div class="name">{{ product.label }}</div>
                                        </div>
                                        <app-truncate-text
                                            [customClasses]="'truncate-text-product-description'"
                                            [clampLines]="2"
                                            [text]="product.description" />
                                    </div>
                                    <div class="action-wrapper">
                                        <div class="price-block">
                                            @if (product_prices[product.id]?.marked_price; as markedPrice) {
                                                <div class="price product-marked-price">&#8377;&nbsp;{{ markedPrice }}</div>
                                            }
                                            @if (product_prices[product.id]?.price; as originalPrice) {
                                                <div class="price">&#8377;&nbsp;{{ originalPrice }}</div>
                                            }
                                        </div>
                                        <ui-counter-button
                                            [counter]="productQuantities[product.id] || 0"
                                            [disabled]="!isAddButtonActive(product.id)"
                                            [buttonLabel]="getButtonLabel(product.id)"
                                            (onCounterChange)="updateCart($event, product.id)"
                                            (handleDisabledState)="handleDisabledState(product)">
                                        </ui-counter-button>
                                    </div>
                                </div>
                            </div>
                            <app-pass-strip
                                [product]="product"
                                [passModel]="passModel"
                                [productPrices]="product_prices"
                                [deployUrl]="DEPLOY_URL">
                            </app-pass-strip>
                        </div>
                    }
                </div>
            </div>
        </div>
        <div class="space-50"></div>
    </div>

    @if (showCartStrip && isMobile) {
        <div style="position: fixed; bottom: 0; z-index: 2">
            <bottom-strip [strip]="cartStrip"></bottom-strip>
        </div>
    }
}

@if (recentSearch && recentSearch.length && showRecentSearch) {
    <div class="container max-width">
        <div class="clearfix"></div>
        <div class="space-40"></div>
        <div class="clearfix"></div>
        <div class="recent-text">Recent Searches</div>
        <div style="display: flex; flex-wrap: wrap">
            @for (search of recentSearch; track search) {
                <div class="search-item" (click)="_onSelect(search)" role="button" tabindex="0">{{ search }}</div>
            }
        </div>
    </div>
}

@if (noResultFound && !showRecentSearch) {
    <div>
        <div class="col-sm-12 text-center">
            <div class="space-50"></div>
            <div class="clearfix"></div>
            <img src="{{ DEPLOY_URL }}/assets/images/empty_cart.svg" alt="Empty cart" />
            <div class="clearfix"></div>
            <div class="space-30"></div>
            <div class="clearfix"></div>
            <h3>No results found</h3>
            <div class="not-found-text">Please try different search.</div>
            <div class="clearfix"></div>
            <div class="space-30"></div>
            <div class="clearfix"></div>
            <div class="space-80"></div>
        </div>
    </div>
}
